import { render, staticRenderFns } from "./punishDishonestyDetail.vue?vue&type=template&id=0b341fd5&scoped=true"
import script from "./punishDishonestyDetail.vue?vue&type=script&lang=js"
export * from "./punishDishonestyDetail.vue?vue&type=script&lang=js"
import style0 from "./punishDishonestyDetail.vue?vue&type=style&index=0&id=0b341fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b341fd5",
  null
  
)

export default component.exports